
const product = [
    {
        id:1,
        title: "LEISURE SET",
        price: '389',
        currency:'$',
        img: "/products_image/1_LEISURE SET-1.jpg",
        colors: ["white"],
        size: ["oversize"],
        slug: "LEISURE SET_01",
    },
    {
        id:2,
        title: "TURN OVER JEANS - CLASSIC",
        price: '248',
        currency:'$',
        img: "/products_image/2_TURN OVER JEANS - CLASSIC-1.jpg",
        colors: ["blue"],
        size: ["s", "m"],
        slug: "TURN OVER JEANS - CLASSIC_02",
    },
    {
        id:3,
        title: "TURN OVER JEANS - CLASSIC",
        price: '248',
        currency:'$',
        img: "/products_image/3_WHISKER SKORTS-1.jpg",
        colors: ["blue"],
        size: ["s", "m"],
        slug: "WHISKER SKORTS-1",
    },
]
export default product;